import { TokenUtil } from "../utils/TokenUtil";
import * as userReducer from "../redux/users/users.reducers";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import SpinnerUI from "../modules/ui/components/spinner/SpinnerUI";
import { Box, Grid, Typography } from "@mui/material";
import MainNavBar from "../modules/layout/pages/navbar/MainNavBar";
import LayoutHeading from "../modules/layout/components/layout-heading/LayoutHeading";

function AdminRoute({ children }: any) {
  const userState: userReducer.InitialState = useSelector(
    (state: RootState) => {
      return state[userReducer.userFeatureKey];
    }
  );

  let { user, loading } = userState;

  const auth = TokenUtil.isLoggedIn();
  return auth && user.isAdmin ? (
    children
  ) : (
    <>
      {loading && <SpinnerUI />}
      <MainNavBar />
      <LayoutHeading heading="Admin Page" description="Only Admin Can Access" />
      <Grid container>
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <Box>
            <Typography
              sx={{
                fontFamily: "Ubuntu",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              You are not authorized to access this..
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default AdminRoute;
